var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Sort',{attrs:{"options":_vm.options,"sort-key":_vm.options[0].key,"selected-value":"おすすめ順"}})}
var staticRenderFns = []

export { render, staticRenderFns }